/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetUsersPreferencesUnitsStatus200, GetUsersPreferencesUnitsStatus401 } from '../types/GetUsersPreferencesUnits'
import type { QueryKey, QueryClient, UseSuspenseQueryOptions, UseSuspenseQueryResult } from '@tanstack/react-query'
import { getUsersPreferencesUnits } from '../clients/getUsersPreferencesUnits'
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'

export const getUsersPreferencesUnitsSuspenseQueryKey = () => [{ url: '/users/preferences/units/' }] as const

type GetUsersPreferencesUnitsSuspenseQueryKey = ReturnType<typeof getUsersPreferencesUnitsSuspenseQueryKey>

export function getUsersPreferencesUnitsSuspenseQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getUsersPreferencesUnitsSuspenseQueryKey()
  return queryOptions<GetUsersPreferencesUnitsStatus200, ResponseErrorConfig<GetUsersPreferencesUnitsStatus401>, GetUsersPreferencesUnitsStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getUsersPreferencesUnits({ ...config, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /users/preferences/units/}
 */
export function useGetUsersPreferencesUnitsSuspense<TData = GetUsersPreferencesUnitsStatus200, TQueryKey extends QueryKey = GetUsersPreferencesUnitsSuspenseQueryKey>(options: {
  query?: Partial<UseSuspenseQueryOptions<GetUsersPreferencesUnitsStatus200, ResponseErrorConfig<GetUsersPreferencesUnitsStatus401>, TData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getUsersPreferencesUnitsSuspenseQueryKey()

  const queryResult = useSuspenseQuery({
   ...getUsersPreferencesUnitsSuspenseQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as UseSuspenseQueryOptions, queryClient) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetUsersPreferencesUnitsStatus401>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
